export const fonts = {
  body: "BC Sans",
  heading: "BC Sans",
  mono: "BC Sans",
}
